import API from ".";

export const vintageReportOverall = async (filters: any) => {
  try {
    const state = filters.state ?? "";
    const territory = filters.territory ?? "";
    const cluster = filters.cluster ?? "";
    const branch = filters.branch ?? "";
    const highRisk = filters.highRiskBranch ?? "";
    const productType = filters.productType ?? "";
    const releationType = filters.relationType ?? "";
    const vintage = filters.vintage ?? "";


    const response = await API.get(`/generate/vintage/overall_by_count?vintage=${vintage}&product_type=${productType}&relation_type=${releationType}&is_high_risk=${highRisk}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const vintageReportRupees = async (filters: any) => {
  try {
    const state = filters.state ?? "";
    const territory = filters.territory ?? "";
    const cluster = filters.cluster ?? "";
    const branch = filters.branch ?? "";
    const highRisk = filters.highRiskBranch ?? "";
    const productType = filters.productType ?? "";
    const releationType = filters.relationType ?? "";
    const vintage = filters.vintage ?? "";


    const response = await API.get(`/generate/vintage/overall_by_amount?vintage=${vintage}&product_type=${productType}&relation_type=${releationType}&is_high_risk=${highRisk}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};